<template>
    <div class="intelligence-chart intelligence-chart--constraints">
        <h3 class="intelligence-chart__title">{{ $t('pages.intelligence.charts.constraint_breakdown') }}</h3>
        <div v-if="hasData" class="intelligence-chart__body">
            <apexchart type="bar" height="280" :options="chartOptions" :series="series"></apexchart>
        </div>
        <p v-else class="intelligence-chart__empty">{{ $t('pages.intelligence.overview.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            breakdown: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            hasData() {
                return this.breakdown.length > 0
            },

            topItems() {
                return this.breakdown.slice(0, 8)
            },

            series() {
                return [
                    {
                        name: 'Count',
                        data: this.topItems.map((item) => item.count),
                    },
                ]
            },

            chartOptions() {
                return {
                    chart: {
                        type: 'bar',
                        toolbar: { show: false },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            columnWidth: '55%',
                        },
                    },
                    colors: ['#ef4444'],
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: this.topItems.map((item) => item.reasonCode),
                        labels: {
                            rotate: -35,
                            trim: true,
                            style: {
                                fontSize: '11px',
                            },
                        },
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => Math.round(value),
                        },
                    },
                    grid: {
                        borderColor: '#e5e7eb',
                    },
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-chart {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-chart__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-chart__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
